import React from 'react';
import './General.css';
import { Helmet } from 'react-helmet';


const Contact = () => {
  return (
    <div className='general-content'>
      <Helmet>
        <title>Contact FaceLead</title>
        <meta name="description" content="Contact FaceLead for inquiries, support, or feedback." />
      </Helmet>
      <h1>Contact</h1>
      <p>
        Thanks for your interest in FaceLead! If you have any inquiry related to the app, 
        please do not hesitate to contact at{' '}
        <a href="mailto:faceleadapp@gmail.com">faceleadapp@gmail.com</a>.
      </p>
    </div>
  );
};

export default Contact;
